import Immutable from 'immutable';
import { offerListActionTypes } from '~constants/actionTypes';
import { defaultCommunicationObject, updateCommunicationObject } from '~reducers/shared';

export const defaultState = Immutable.fromJS({
  list: {
    payload: [],
    total: 0,
  },
  operatingOffer: {},
  communication: {
    list: defaultCommunicationObject,
    create: defaultCommunicationObject,
    update: defaultCommunicationObject,
    delete: defaultCommunicationObject,
  },
});

// const formatUnitTypes = types =>
//   types.edges.map(type => ({
//     id: type.node.id,
//     name: type.node.name,
//     listings: type.node.listings,
//     property: type.node.property,
//   }));

// const formatProperties = properties =>
//   properties.edges.map(property => ({
//     landlord: {
//       name: property.node.landlord ? property.node.landlord.name : '',
//       id: property?.node?.landlord?.id || '',
//     },
//     name: property.node.name,
//     slug: property.node.slug,
//     id: property.node.id,
//   }));

const formatCities = cities =>
  cities.edges.map(city => ({
    name: city.node.name,
    slug: city.node.slug,
    id: city.node.id,
  }));

// const formatListings = listings =>
//   listings.edges.map(listing => ({
//     id: listing.node.id,
//     moveIn: listing.node.moveIn,
//     moveOut: listing.node.moveOut,
//     unitType: listing.node.unitType,
//     type: listing.node.type,
//   }));

const formatPayload = SpecialOffers =>
  SpecialOffers.map(specialOffer => ({
    key: specialOffer.node.id,
    id: specialOffer.node.id,
    internalTitle: specialOffer.node.internalTitle,
    startDate: specialOffer.node.startDate,
    notes: specialOffer.node.notes,
    title: specialOffer.node.title,
    fulfillmentInstructions: specialOffer.node.fulfillmentInstructions,
    cities: formatCities(specialOffer.node.cities),
    propertiesAmount: specialOffer.node.properties.totalCount,
    endDate: specialOffer.node.endDate,
    createdAt: specialOffer.node.createdAt,
    amount: specialOffer.node.amount,
    locales: specialOffer.node.locales,
    referralCode: specialOffer.node.referralCode,
    offerType: specialOffer.node.offerType,
    ownerType: specialOffer.node.ownerType,
    exclusive: specialOffer.node.exclusive,
    description: specialOffer.node.description,
    subDescription: specialOffer.node.subDescription,
    link: specialOffer.node.link,
    termsAndConditions: specialOffer.node.termsAndConditions,
    maxBookings: specialOffer.node.maxBookings,
    ipAddresses: specialOffer.node.ipAddresses,
    minTenancyValue: specialOffer.node.minTenancyValue,
    tenancyUnit: specialOffer.node.tenancyUnit,
    rank: specialOffer.node.rank,
  }));

const formatListPayload = SpecialOffers =>
  SpecialOffers.map(specialOffer => ({
    key: specialOffer.node.id,
    id: specialOffer.node.id,
    internalTitle: specialOffer.node.internalTitle,
    startDate: specialOffer.node.startDate,
    notes: specialOffer.node.notes,
    title: specialOffer.node.title,
    fulfillmentInstructions: specialOffer.node.fulfillmentInstructions,
    cities: formatCities(specialOffer.node.cities),
    endDate: specialOffer.node.endDate,
    createdAt: specialOffer.node.createdAt,
    amount: specialOffer.node.amount,
    locales: specialOffer.node.locales,
    referralCode: specialOffer.node.referralCode,
    offerType: specialOffer.node.offerType,
    ownerType: specialOffer.node.ownerType,
    exclusive: specialOffer.node.exclusive,
    description: specialOffer.node.description,
    link: specialOffer.node.link,
    termsAndConditions: specialOffer.node.termsAndConditions,
    maxBookings: specialOffer.node.maxBookings,
    ipAddresses: specialOffer.node.ipAddresses,
    minTenancyValue: specialOffer.node.minTenancyValue,
    tenancyUnit: specialOffer.node.tenancyUnit,
    rank: specialOffer.node.rank,
  }));

const SpecialOffersListReducer = (state = defaultState, action) => {
  switch (action.type) {
    case offerListActionTypes.INITIALIZE:
      return state;

    case offerListActionTypes.SET_LIST: {
      const nextState = state.deleteIn(['list', 'payload']);
      return nextState.mergeDeep({
        list: {
          payload: formatListPayload(action.payload.edges),
          total: action.payload.totalCount,
        },
      });
    }

    case offerListActionTypes.LIST_CS:
      return state.mergeDeep({
        communication: {
          list: updateCommunicationObject(action.status, action.error),
        },
      });

    case offerListActionTypes.CREATE_CS:
      return state.mergeDeep({
        communication: {
          create: updateCommunicationObject(action.status, action.error),
        },
      });

    case offerListActionTypes.UPDATE_CS:
      return state.mergeDeep({
        communication: {
          update: updateCommunicationObject(action.status, action.error),
        },
      });

    case offerListActionTypes.DELETE_CS:
      return state.mergeDeep({
        communication: {
          delete: updateCommunicationObject(action.status, action.error),
        },
      });

    case offerListActionTypes.SET_OPERATING_OFFER: {
      const nextState = state.deleteIn(['operatingOffer']);

      return nextState.mergeDeep({
        operatingOffer: action.payload ? formatPayload([{ node: action.payload }])[0] : {},
        communication: {
          list: updateCommunicationObject(action.status, action.error),
        },
      });
    }

    default:
      return state;
  }
};

export default SpecialOffersListReducer;
